"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setDataFirebase = void 0;
var firebaseInstance;
var setDataFirebase = function (newFirebase) {
    firebaseInstance = newFirebase;
};
exports.setDataFirebase = setDataFirebase;
exports.default = (function () { return firebaseInstance; });
//# sourceMappingURL=firebase.js.map